
import { useState, useEffect } from 'react';
import Title from '../../Text/Title/Title';
import { SubTitle } from '../../Text/Subtitle/SubTitle.tsx';
import { useNotification } from '../../../hooks/useNotification';
import useApiRequests from '../../../hooks/useApiRequests.tsx';
import { useNavigate } from 'react-router-dom';
import { ITool } from '../../../interfaces/ITool.tsx';
import BigText from '../../Text/BigText/BigText';
import { FillingBottle } from 'react-cssfx-loading';
import { TableContainer, Paper, TableCell, TableRow, Table, TableHead, TableBody } from '@mui/material';
import { FaPen, FaTrash } from 'react-icons/fa6';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col } from 'reactstrap';
import { FaArrowAltCircleLeft, FaArrowAltCircleRight } from 'react-icons/fa';
import { Tooltip } from 'react-tooltip';


export default function Tools() {
  const { notify } = useNotification();
  const { getAllTools, deleteTool } = useApiRequests();
  const navigate = useNavigate();

  const [tools, setTools] = useState<ITool[]>();  
  const [pageItens, setPageItens] = useState<ITool[]>([]);

  const [itemToDelete, setItemToDelete] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const [pagination, setPagination] = useState({
    data: null,
    page: 0,
    itemsPerPage: 25,
    totalPages: 0,
  });

  useEffect(() => {
    const startIndex = pagination.page * pagination.itemsPerPage;
    const endIndex = startIndex + pagination.itemsPerPage;
    const slicedItens =
      pagination.data && pagination.data.slice(startIndex, endIndex);
      setPageItens(slicedItens||[]);
  }, [pagination]);


  useEffect(() => {
      fetchData();
  }, []);


  const fetchData = async () => {
    try{
      const data = await getAllTools();
      if(data.success){
        const totalPages = Math.ceil(
          data.data.length / pagination.itemsPerPage
        );

        // Update pagination data
        setPagination((prevPagination) => ({
          ...prevPagination,
          data: data.data,
          totalPages,
        }));

        const startIndex = pagination.page * pagination.itemsPerPage;
        const endIndex = startIndex + pagination.itemsPerPage;
        const slicedItens = data.data && data.data.slice(startIndex, endIndex);
        setPageItens(slicedItens);
        setTools(data.data);
      }else{
        notify("Ocorreu um erro ao buscar os dados", {type: "error"});
      }
    }catch(error){
      notify(error, {type: "error"});
    }
  };

  const handleEditItem = (id: string) => {
      navigate(`/tool/edit/${id}`);
  };

  const handleDeleteItem = async () => {
    try{
      const data = await deleteTool(itemToDelete);
      fetchData();
      setItemToDelete("");
      setDeleteModal(false);
    }catch(error){
      notify(error, {type: "error"});
    }
  }; 

  const handlePageChange = (newPage: any) => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      page: newPage,
    }));
  };

  const handleNewTool = () => {
    navigate(`/tool/edit/new`);
  };

  const handleGoBack = () => {
    const lastHref = localStorage.getItem("lastHref");
    window.location.href = lastHref || "";
  };

  return (
      <div className='page-container'>
          <Tooltip id="edit-dropdown" />
          <Tooltip id="delete-dropdown" />
          <Row className="d-flex align-center justify-content-between w-100">
            <Col className="title-and-subtitle">
            <Title>Ferramentas</Title>
              <SubTitle>VendaERP</SubTitle>
            </Col>
          

            <Col className='d-flex gap-2 justify-content-end'>
            <Button
              color="secondary"
              style={{ height: "44px" }}
              onClick={() => handleGoBack()}
            >
              Voltar
            </Button>
            <Button color="success" style={{height: "44px"}} onClick={() => handleNewTool()}>Nova Ferramenta</Button>
            </Col>
          </Row>





          <div className='mt-5'>
            {pageItens == null  ? (
              <div className="d-flex flex-column justify-content-center align-items-center gap-5 mt-5">
                <BigText type={1}>Carregando...</BigText>
                <FillingBottle width="100px" height="100px" color="#dddcdc" />
              </div>
            ) : (
              <>
                {pageItens.length == 0 && <BigText type={1}>Nenhum Item Encontrado</BigText>}
                {pageItens.length > 0 && 
                  <>
                    <TableContainer  className="mb-5">
                      <Table aria-label="collapsible table">
                        <TableHead>
                          <TableRow>
                            <TableCell className="th-text" >Ferramenta</TableCell>
                            <TableCell/>
                            <TableCell/>                    
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {pageItens.length > 0 && pageItens.map((item, index) => {
                            return (
                              <TableRow key={index} sx={{ '& > *': { borderBottom: 'unset' } }} onDoubleClick={() => handleEditItem(item.id||"")}>
                                <TableCell className="theme-text-color" >{item.name}</TableCell>
                                <TableCell align="right" width={20}>
                                  <FaPen
                                    className="pointer"
                                    color="#0d6efd"
                                    data-tooltip-id="edit-dropdown"
                                    data-tooltip-content="Editar"
                                    data-tooltip-place="top"
                                    onClick={() => handleEditItem(item.id||"")}
                                  />
                                </TableCell>
                                <TableCell align="right" width={20}>
                                  <FaTrash
                                    className="pointer"
                                    color="#ff5e00"
                                    onClick={() => {
                                      setItemToDelete(item.id||"");
                                      setDeleteModal(!deleteModal);
                                    }}
                                    data-tooltip-id="delete-dropdown"
                                    data-tooltip-content="Deletar"
                                    data-tooltip-place="top"
                                  />
                                </TableCell>
                              </TableRow>
                            )})}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <div className="pagination-container">
                      <Button
                        color="primary"
                        onClick={() => handlePageChange(pagination.page - 1)}
                        disabled={pagination.page === 0}
                      >
                        <FaArrowAltCircleLeft color="#fff" size={24} />
                      </Button>
                      <span className="pagination-index">
                        {" "}
                        Página {pagination.page + 1} de {pagination.totalPages}{" "}
                      </span>
                      <Button
                        color="primary"
                        onClick={() => handlePageChange(pagination.page + 1)}
                        disabled={pagination.page === pagination.totalPages - 1}
                      >
                        <FaArrowAltCircleRight color="#fff" size={24} />
                      </Button>
                    </div>
                  </>
                }
              </>
            )}
          </div>
          <Modal isOpen={deleteModal} toggle={() => setDeleteModal(false)}>
            <ModalHeader toggle={() => setDeleteModal(false)}>Deletar Tarefa</ModalHeader>
            <ModalBody>
              Esta ação não poderá ser desfeita! Tem certeza que deseja deletar a tarefa?
            </ModalBody>
            <ModalFooter>
              <Button color="primary" onClick={() => handleDeleteItem()}>
                Deletar
              </Button>{' '}
              <Button color="secondary" onClick={() => setDeleteModal(false)}>
                Cancelar
              </Button>
            </ModalFooter>
          </Modal>
      </div>
  );
}
